import { User } from 'services/interface';

// The Explore Data (stats) page is restricted to authenticated OPSWAT staff only.
// Access is granted when the user is logged in AND their SSO email is on the @opswat.com domain.
const OPSWAT_EMAIL_REGEX = /@opswat\.com$/i;

const normalizeEmail = (email: string | undefined): string => (email ?? '').trim().toLowerCase();

export const isOpswatEmail = (email: string | undefined): boolean => OPSWAT_EMAIL_REGEX.test(normalizeEmail(email));

export const canAccessStatsPage = (user: User | null | undefined): boolean =>
    Boolean(user?.isLoggedIn) && isOpswatEmail(user?.email);
